// extracted by mini-css-extract-plugin
export var childrenContainer = "_co-0";
export var virtualScrollArea = "_co-1";